import { Phone, MessageCircle, Facebook, MapPin, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE, waLink } from "@/lib/site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0A2540] text-slate-300">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <p className="font-heading text-xl font-extrabold text-white">{SITE.agency}</p>
            <p className="mt-1 text-sm text-slate-400">{SITE.agentName} • {SITE.role}</p>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              Membantu rakyat Malaysia memiliki rumah idaman melalui khidmat pinjaman
              perumahan yang telus, mudah dan selamat.
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-emerald-400">
              <ShieldCheck className="h-4 w-4" /> Maklumat anda sentiasa dirahsiakan
            </div>
          </div>

          <div>
            <p className="font-heading font-bold text-white">Hubungi Saya</p>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 text-[#F59E0B]" />
                <a href={`tel:+${SITE.phoneRaw}`} className="hover:text-white transition-colors" data-testid="footer-phone">
                  {SITE.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="h-4 w-4 text-[#10B981]" />
                <a href={waLink()} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-whatsapp">
                  WhatsApp
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Facebook className="h-4 w-4 text-[#1877F2]" />
                <a href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-facebook">
                  Facebook
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-slate-400" />
                <span>Malaysia</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-heading font-bold text-white">Sedia untuk mula?</p>
            <p className="mt-4 text-sm text-slate-400">
              Semak kelayakan pinjaman perumahan anda secara percuma hari ini.
            </p>
            <a href="#mohon" data-testid="footer-apply-btn">
              <Button className="mt-5 h-11 px-6 bg-[#F59E0B] hover:bg-[#e08e07] text-[#0A2540] font-semibold rounded-full transition-transform hover:scale-105">
                Semak Kelayakan Sekarang
              </Button>
            </a>
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {SITE.agency}. Hak cipta terpelihara.
          </p>
          <a href="/admin" className="text-xs text-slate-600 hover:text-slate-400 transition-colors" data-testid="footer-admin-link">
            Portal Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
